module.exports = __webpack_public_path__ + "static/media/PHO_ID_CMYK_BLK_FixedX-01.27a0321d.svg";